var _style, _g, _g2, _g3, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _g4, _path9, _line, _line2, _line3, _line4, _line5, _line6, _line7, _line8, _line9, _line10, _line11, _line12, _line13, _line14, _line15, _line16, _line17, _line18, _line19, _line20, _line21, _line22, _line23, _line24;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgGameOver(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "\\u5716\\u5C64_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 377.7 131.7",
    style: {
      enableBackground: "new 0 0 377.7 131.7"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{enable-background:new    ;}\n\t.st1{fill:url(#SVGID_1_);}\n\t.st2{fill:url(#SVGID_2_);}\n\t.st3{fill:url(#SVGID_3_);}\n\t.st4{fill:url(#SVGID_4_);}\n\t.st5{fill:url(#SVGID_5_);}\n\t.st6{fill:url(#SVGID_6_);}\n\t.st7{fill:url(#SVGID_7_);}\n\t.st8{fill:url(#SVGID_8_);}\n\t.st9{fill:url(#SVGID_9_);}\n\t.st10{fill:none;stroke:#000000;stroke-miterlimit:10;}\n\t.st11{fill:none;stroke:#FFE300;stroke-miterlimit:10;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "st0"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M26.2,78.5l-2.3-1l3.6-8.2l17.7,6.7L41,110.5l-15.9-1.3c0.6-1.7,1.4-4.2,2.4-7.3c1-3.2,1.7-5.3,2-6.2c-1.4,0.7-4.1,1-8.2,1 c-3.9,0-7.4-0.7-10.4-2.2c-3-1.5-5.4-4-7.4-7.7c-1.9-3.6-3.1-8.5-3.5-14.7C0,71.5,0,70.5,0,69.3c0-3.1,0.4-6,1.1-8.9 C1.8,57.6,3,55,4.6,52.8c1.6-2.3,3.9-4.1,6.8-5.6s6.4-2.2,10.4-2.2c2.7,0,5.4,0.3,8,1c2.6,0.6,5,1.5,7.2,2.7 c2.2,1.1,4.1,2.5,5.6,4.2c1.6,1.6,2.6,3.4,3.1,5.3l-14,9.2c-0.9-2.3-4.1-3.5-9.4-3.5c-1.2,0-2.4,0.9-3.7,2.6 c-1.3,1.7-1.9,3.7-1.9,5.8c0.1,1.6,0.6,3.2,1.5,4.7c0.9,1.5,2.4,2.3,4.7,2.4c0.2,0,0.5-0.1,1-0.2c0.5-0.1,0.9-0.2,1.2-0.3 C25.4,78.6,25.8,78.5,26.2,78.5z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61,39.8l30.7,74l-13.1,1.3L64.1,81l-8.2-1.3l-12.8,27.1l-16.2,0.8L61,39.8z M56.4,72.3l7.4,1l-3.1-12L56.4,72.3z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M80.8,50.8l15.4-1l4.1,6.7l3.6-9.2l10-0.2l11.8,54.8l-18.2-1.8l-3.3-18.7l-3.6,6.9l-4.8-8.7l-1.6,15.8l-17.7,1.3L80.8,50.8 z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M137.4,93.3l32.8,1.5l-0.2,13.6l-45.6-2.3L121.8,59l-4.4,0.8l0.8-14.8l37.9-5.7l0.8,13.6l-21.5,3.6l0.5,9.8l21.2-3.6 l0.8,11.3l-21.5,4.1L137.4,93.3z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M231.8,50.6c4.9,3.8,7.4,8.8,7.4,15.1c0,2.2-0.3,4.4-0.9,6.7c-0.6,2.3-1.5,4.5-2.6,6.6c-1.1,2.1-2.3,4-3.7,5.6 c-2.2,2.7-4.3,5-6.5,6.8c-2.1,1.9-4.3,3.4-6.5,4.5s-4.3,2-6.3,2.5c-2,0.5-4,0.8-5.9,0.8c-4.5,0-8.6-1.2-12.2-3.6 c-2.5-1.7-4.5-4.3-6.1-7.8c-1.6-3.5-2.4-7.3-2.4-11.4c0-6.5,2.1-12.1,6.2-16.9c2.4-2.8,5-5.3,7.7-7.4c2.7-2.2,5.5-3.9,8.3-5.1 c2.9-1.2,5.8-1.9,8.8-1.9C222.1,45.1,227,46.9,231.8,50.6z M225.6,58.6c-0.4,2.3-1.3,4.3-2.5,5.8c-1.3,1.5-2.6,2.3-3.9,2.3 c-0.9,0-1.6-0.3-2.2-1c-0.3-0.3-0.6-0.8-0.8-1.5c-0.2-0.7-0.3-1.3-0.3-1.9c0-1.3,0.4-2.5,1.1-3.8c0.8-1.2,2-2.3,3.6-3.2 c-2,0-3.7,0.5-5.1,1.4c-1.4,0.9-2.4,2.1-3.1,3.5s-1,2.9-1,4.5c0,2.4,0.7,4.2,2.1,5.3c1.7,1.4,3.4,2.1,5.1,2.1 c2.1,0,3.9-0.9,5.3-2.8s2.2-4.2,2.2-7C226,61,225.9,59.8,225.6,58.6z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M237,49.8l-5.4-1.3l-0.3-7.9l19,1.3L262.1,79l8.5-34.8l18.2,1L269.8,103l-14.1-0.2L237,49.8z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M297.4,93.3l32.8,1.5l-0.2,13.6l-45.6-2.3L281.8,59l-4.4,0.8l0.8-14.8l37.9-5.7l0.8,13.6l-21.5,3.6l0.5,9.8l21.2-3.6 l0.8,11.3l-21.5,4.1L297.4,93.3z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M339.4,69.7c-0.8,0.8-1.6,1.5-2.4,2.3c-0.9,0.8-1.5,1.3-1.8,1.6l4.1,22.8l-10.8,2.8l-6.4-40.7c-0.1,0-0.4,0.2-0.7,0.6 s-0.8,0.9-1.4,1.6s-0.9,1.1-1,1.2c-0.1,0-0.3-0.4-0.6-1.3c-0.3-0.9-0.8-2.1-1.4-3.7s-1.2-3.4-1.9-5.3c-0.7-1.9-1.2-3.2-1.5-3.7 c2.5-0.8,4.9-1.6,7.1-2.3c2.2-0.7,4.6-1.4,7-2c2.5-0.6,4.8-1.1,7-1.5s4.4-0.6,6.6-0.6c1.7,0,3.2,0.1,4.7,0.4c1.4,0.3,2.8,0.7,4,1.3 c1.3,0.6,2.4,1.4,3.4,2.4c1,1,1.8,2.2,2.4,3.6c0.2,0.4,0.3,0.9,0.3,1.6c0,1-0.3,2.1-0.9,3.4s-1.4,2.5-2.4,3.9 c-1,1.4-2.1,2.8-3.4,4.2c1.1,0.1,2.2,1,3.3,2.5c1.1,1.5,1.8,3.3,2.3,5.4l5.4,27.7l-9.5,2.1l-6.9-25.3c-0.1-0.4-0.4-0.9-0.7-1.6 s-0.8-1.4-1.4-2.1c-0.6-0.7-1.2-1.1-1.9-1.1C339.9,69.6,339.7,69.6,339.4,69.7z M331.8,55.4l1.8,9.2c1.4-0.3,2.9-1.5,4.6-3.6 c1.7-2.1,2.5-3.8,2.5-5c0-0.6-0.2-1-0.8-1.2c-2.1-0.5-3.6-0.8-4.3-0.8C334.4,54.1,333.1,54.5,331.8,55.4z"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    className: "st0"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    className: "st0"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M361.1,75.7L357,41.1l18.7-5.6l-3.8,39.2L361.1,75.7z M365.8,84.3c1.5,0,2.8,0.2,3.8,0.7c1.1,0.5,2,1.1,2.6,1.8 c0.7,0.7,1.2,1.3,1.4,1.8c0.2,0.6,0.4,1.2,0.4,1.9c0,1-0.2,2-0.7,3.1s-1,1.9-1.6,2.7s-1.2,1.2-1.8,1.3c-1.1,0.2-1.9,0.2-2.4,0.2 c-2.1,0-3.7-0.5-5-1.6c-1.2-1.1-2-2.5-2.2-4.4c0-1.8,0.4-3.5,1.3-5C362.5,85.4,363.9,84.5,365.8,84.3z"
  }))), /*#__PURE__*/React.createElement("g", {
    className: "st0"
  }, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_1_",
    gradientUnits: "userSpaceOnUse",
    x1: 24.8799,
    y1: 114.4625,
    x2: 24.8799,
    y2: 48.9313
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFE300"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#D49A00"
    }
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M28.2,82.5l-2.3-1l3.6-8.2l17.7,6.7L43,114.5l-15.9-1.3c0.6-1.7,1.4-4.2,2.4-7.3c1-3.2,1.7-5.3,2-6.2 c-1.4,0.7-4.1,1-8.2,1c-3.9,0-7.4-0.7-10.4-2.2c-3-1.5-5.4-4-7.4-7.7c-1.9-3.6-3.1-8.5-3.5-14.7C2,75.5,2,74.5,2,73.3 c0-3.1,0.4-6,1.1-8.9C3.8,61.6,5,59,6.6,56.8c1.6-2.3,3.9-4.1,6.8-5.6s6.4-2.2,10.4-2.2c2.7,0,5.4,0.3,8,1c2.6,0.6,5,1.5,7.2,2.7 c2.2,1.1,4.1,2.5,5.6,4.2c1.6,1.6,2.6,3.4,3.1,5.3l-14,9.2c-0.9-2.3-4.1-3.5-9.4-3.5c-1.2,0-2.4,0.9-3.7,2.6 c-1.3,1.7-1.9,3.7-1.9,5.8c0.1,1.6,0.6,3.2,1.5,4.7c0.9,1.5,2.4,2.3,4.7,2.4c0.2,0,0.5-0.1,1-0.2c0.5-0.1,0.9-0.2,1.2-0.3 C27.4,82.6,27.8,82.5,28.2,82.5z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_2_",
    gradientUnits: "userSpaceOnUse",
    x1: 61.333,
    y1: 119.0563,
    x2: 61.333,
    y2: 43.8063
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFE300"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#D49A00"
    }
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M63,43.8l30.7,74l-13.1,1.3L66.1,85l-8.2-1.3l-12.8,27.1l-16.2,0.8L63,43.8z M58.4,76.3l7.4,1l-3.1-12 L58.4,76.3z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_3_",
    gradientUnits: "userSpaceOnUse",
    x1: 103.0518,
    y1: 105.7438,
    x2: 103.0518,
    y2: 50.9625
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFE300"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#D49A00"
    }
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M82.8,54.8l15.4-1l4.1,6.7l3.6-9.2l10-0.2l11.8,54.8l-18.2-1.8l-3.3-18.7l-3.6,6.9l-4.8-8.7l-1.6,15.8 l-17.7,1.3L82.8,54.8z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_4_",
    gradientUnits: "userSpaceOnUse",
    x1: 145.8174,
    y1: 112.4,
    x2: 145.8174,
    y2: 43.275
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFE300"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#D49A00"
    }
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M139.4,97.3l32.8,1.5l-0.2,13.6l-45.6-2.3L123.8,63l-4.4,0.8l0.8-14.8l37.9-5.7l0.8,13.6l-21.5,3.6l0.5,9.8 l21.2-3.6l0.8,11.2l-21.5,4.1L139.4,97.3z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_5_",
    gradientUnits: "userSpaceOnUse",
    x1: 214.6299,
    y1: 103.2438,
    x2: 214.6299,
    y2: 49.1188
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFE300"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#D49A00"
    }
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M233.8,54.6c4.9,3.8,7.4,8.8,7.4,15.1c0,2.2-0.3,4.4-0.9,6.7c-0.6,2.3-1.5,4.5-2.6,6.6c-1.1,2.1-2.3,4-3.7,5.6 c-2.2,2.7-4.3,5-6.5,6.8c-2.1,1.9-4.3,3.4-6.5,4.5s-4.3,2-6.3,2.5c-2,0.5-4,0.8-5.9,0.8c-4.5,0-8.6-1.2-12.2-3.6 c-2.5-1.7-4.5-4.3-6.1-7.8c-1.6-3.5-2.4-7.3-2.4-11.4c0-6.5,2.1-12.1,6.2-16.9c2.4-2.8,5-5.3,7.7-7.4c2.7-2.2,5.5-3.9,8.3-5.1 c2.9-1.2,5.8-1.9,8.8-1.9C224.1,49.1,229,50.9,233.8,54.6z M227.6,62.6c-0.4,2.3-1.3,4.3-2.5,5.8c-1.3,1.5-2.6,2.3-3.9,2.3 c-0.9,0-1.6-0.3-2.2-1c-0.3-0.3-0.6-0.8-0.8-1.5c-0.2-0.7-0.3-1.3-0.3-1.9c0-1.3,0.4-2.5,1.1-3.8c0.8-1.2,2-2.3,3.6-3.2 c-2,0-3.7,0.5-5.1,1.4c-1.4,0.9-2.4,2.1-3.1,3.5c-0.7,1.4-1,2.9-1,4.5c0,2.4,0.7,4.2,2.1,5.3c1.7,1.4,3.4,2.1,5.1,2.1 c2.1,0,3.9-0.9,5.3-2.8s2.2-4.2,2.2-7C228,65,227.9,63.8,227.6,62.6z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_6_",
    gradientUnits: "userSpaceOnUse",
    x1: 262.0205,
    y1: 107.025,
    x2: 262.0205,
    y2: 44.5563
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFE300"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#D49A00"
    }
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M239,53.8l-5.4-1.3l-0.3-7.9l19,1.3L264.1,83l8.5-34.8l18.2,1L271.8,107l-14.1-0.2L239,53.8z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_7_",
    gradientUnits: "userSpaceOnUse",
    x1: 305.8174,
    y1: 112.4,
    x2: 305.8174,
    y2: 43.275
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFE300"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#D49A00"
    }
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M299.4,97.3l32.8,1.5l-0.2,13.6l-45.6-2.3L283.8,63l-4.4,0.8l0.8-14.8l37.9-5.7l0.8,13.6l-21.5,3.6l0.5,9.8 l21.2-3.6l0.8,11.2l-21.5,4.1L299.4,97.3z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_8_",
    gradientUnits: "userSpaceOnUse",
    x1: 339.083,
    y1: 103.7125,
    x2: 339.083,
    y2: 45.3375
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFE300"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#D49A00"
    }
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M341.4,73.7c-0.8,0.8-1.6,1.5-2.4,2.3c-0.9,0.8-1.5,1.3-1.8,1.6l4.1,22.8l-10.8,2.8l-6.4-40.7 c-0.1,0-0.4,0.2-0.7,0.6s-0.8,0.9-1.4,1.6c-0.6,0.7-0.9,1.1-1,1.2c-0.1,0-0.3-0.4-0.6-1.3c-0.3-0.9-0.8-2.1-1.4-3.7 s-1.2-3.4-1.9-5.3c-0.7-1.9-1.2-3.2-1.5-3.7c2.5-0.8,4.9-1.6,7.1-2.3c2.2-0.7,4.6-1.4,7-2c2.5-0.6,4.8-1.1,7-1.5s4.4-0.6,6.6-0.6 c1.7,0,3.2,0.1,4.7,0.4c1.4,0.3,2.8,0.7,4,1.3c1.3,0.6,2.4,1.4,3.4,2.4c1,1,1.8,2.2,2.4,3.6c0.2,0.4,0.3,0.9,0.3,1.6 c0,1-0.3,2.1-0.9,3.4s-1.4,2.5-2.4,3.9c-1,1.4-2.1,2.8-3.4,4.2c1.1,0.1,2.2,1,3.3,2.5s1.8,3.3,2.3,5.4l5.4,27.7l-9.5,2.1l-6.9-25.3 c-0.1-0.4-0.4-0.9-0.7-1.6s-0.8-1.4-1.4-2.1c-0.6-0.7-1.2-1.1-1.9-1.1C341.9,73.6,341.7,73.6,341.4,73.7z M333.8,59.4l1.8,9.2 c1.4-0.3,2.9-1.5,4.6-3.6c1.7-2.1,2.5-3.8,2.5-5c0-0.6-0.2-1-0.8-1.2c-2.1-0.5-3.6-0.8-4.3-0.8C336.4,58.1,335.1,58.5,333.8,59.4z"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    className: "st0"
  })), /*#__PURE__*/React.createElement("g", {
    className: "st0"
  }, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_9_",
    gradientUnits: "userSpaceOnUse",
    x1: 368.3799,
    y1: 101.9,
    x2: 368.3799,
    y2: 39.4625
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFE300"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#D49A00"
    }
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M363.1,79.7L359,45.1l18.7-5.6l-3.8,39.2L363.1,79.7z M367.8,88.3c1.5,0,2.8,0.2,3.8,0.7 c1.1,0.5,2,1.1,2.6,1.8c0.7,0.7,1.2,1.3,1.4,1.8c0.2,0.6,0.4,1.2,0.4,1.9c0,1-0.2,2-0.7,3.1s-1,1.9-1.6,2.7s-1.2,1.2-1.8,1.3 c-1.1,0.2-1.9,0.2-2.4,0.2c-2.1,0-3.7-0.5-5-1.6c-1.2-1.1-2-2.5-2.2-4.4c0-1.8,0.4-3.5,1.3-5C364.5,89.4,365.9,88.5,367.8,88.3z"
  }))), _line || (_line = /*#__PURE__*/React.createElement("line", {
    className: "st10",
    x1: 188.1,
    y1: 39.8,
    x2: 188.1,
    y2: 68.6
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    className: "st10",
    x1: 6.9,
    y1: 25.4,
    x2: 6.9,
    y2: 51.9
  })), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    className: "st10",
    x1: 10.8,
    y1: 19.7,
    x2: 10.8,
    y2: 47.7
  })), _line4 || (_line4 = /*#__PURE__*/React.createElement("line", {
    className: "st10",
    x1: 14.3,
    y1: 25.4,
    x2: 14.3,
    y2: 47.7
  })), _line5 || (_line5 = /*#__PURE__*/React.createElement("line", {
    className: "st10",
    x1: 192.5,
    y1: 36.5,
    x2: 192.5,
    y2: 61.5
  })), _line6 || (_line6 = /*#__PURE__*/React.createElement("line", {
    className: "st10",
    x1: 196.5,
    y1: 33.7,
    x2: 196.5,
    y2: 56.4
  })), _line7 || (_line7 = /*#__PURE__*/React.createElement("line", {
    className: "st10",
    x1: 268.5,
    y1: 13.7,
    x2: 268.5,
    y2: 55.6
  })), _line8 || (_line8 = /*#__PURE__*/React.createElement("line", {
    className: "st10",
    x1: 273,
    y1: 2.7,
    x2: 273,
    y2: 44.6
  })), _line9 || (_line9 = /*#__PURE__*/React.createElement("line", {
    className: "st10",
    x1: 277.4,
    y1: 17.3,
    x2: 277.4,
    y2: 44.6
  })), _line10 || (_line10 = /*#__PURE__*/React.createElement("line", {
    className: "st10",
    x1: 360.5,
    y1: 13.7,
    x2: 360.5,
    y2: 41
  })), _line11 || (_line11 = /*#__PURE__*/React.createElement("line", {
    className: "st10",
    x1: 364,
    y1: 18.7,
    x2: 364,
    y2: 39.3
  })), _line12 || (_line12 = /*#__PURE__*/React.createElement("line", {
    className: "st11",
    x1: 166.3,
    y1: 109.9,
    x2: 166.3,
    y2: 128.3
  })), _line13 || (_line13 = /*#__PURE__*/React.createElement("line", {
    className: "st11",
    x1: 162.8,
    y1: 109.9,
    x2: 162.8,
    y2: 125.7
  })), _line14 || (_line14 = /*#__PURE__*/React.createElement("line", {
    className: "st11",
    x1: 169.8,
    y1: 111.5,
    x2: 169.8,
    y2: 125.5
  })), _line15 || (_line15 = /*#__PURE__*/React.createElement("line", {
    className: "st11",
    x1: 326.8,
    y1: 111.4,
    x2: 326.8,
    y2: 122.2
  })), _line16 || (_line16 = /*#__PURE__*/React.createElement("line", {
    className: "st11",
    x1: 324.4,
    y1: 111.6,
    x2: 324.4,
    y2: 119.8
  })), _line17 || (_line17 = /*#__PURE__*/React.createElement("line", {
    className: "st11",
    x1: 360.5,
    y1: 101.9,
    x2: 360.5,
    y2: 110.1
  })), _line18 || (_line18 = /*#__PURE__*/React.createElement("line", {
    className: "st11",
    x1: 355.1,
    y1: 102.9,
    x2: 355.1,
    y2: 111.1
  })), _line19 || (_line19 = /*#__PURE__*/React.createElement("line", {
    className: "st11",
    x1: 357.7,
    y1: 102.3,
    x2: 357.7,
    y2: 116.2
  })), _line20 || (_line20 = /*#__PURE__*/React.createElement("line", {
    className: "st11",
    x1: 91.7,
    y1: 117.2,
    x2: 91.7,
    y2: 128.3
  })), _line21 || (_line21 = /*#__PURE__*/React.createElement("line", {
    className: "st11",
    x1: 89.2,
    y1: 117.2,
    x2: 89.2,
    y2: 126.8
  })), _line22 || (_line22 = /*#__PURE__*/React.createElement("line", {
    className: "st11",
    x1: 41.7,
    y1: 114.2,
    x2: 41.7,
    y2: 123.9
  })), _line23 || (_line23 = /*#__PURE__*/React.createElement("line", {
    className: "st11",
    x1: 39.2,
    y1: 112.4,
    x2: 39.2,
    y2: 122
  })), _line24 || (_line24 = /*#__PURE__*/React.createElement("line", {
    className: "st11",
    x1: 36.2,
    y1: 112.4,
    x2: 36.2,
    y2: 128.3
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGameOver);
export default __webpack_public_path__ + "static/media/gameOver.e921fd073dc003a9b940b53798e6966b.svg";
export { ForwardRef as ReactComponent };